export const revenueSelector = state =>state.revenueReducer.revenueDetails;
